import React, {useEffect, useState} from 'react'
import styled from "styled-components";
import { breakpoints } from "../../styles/breakpoints.styles";

const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 2rem;
  position: relative;
  
  ${breakpoints('tabPort') `
    width: 100%;
  `} 

  &:focus,
  &.active {
    input {
      outline: none;
      border-bottom-color: ${props => props.theme.colors.primary};
    }
    
    label {
      color: ${props => props.theme.colors.primary};
      top: -5px;
      font-size: 1rem;
    }
  }
`;

const Label = styled.label`
  color: ${props => props.theme.colors.text};
  font-size: 1.4rem;
  margin-bottom: 5px;
  position: absolute;
  top: 50%;
  left: 1.4rem;
  transform: translateY(-50%);
  transition: all .3s;
`;
const Input = styled.input`
  width: 100%;
  height: 3.2rem;
  border-radius: 0;
  border: none;
  border-bottom: 1px solid rgba(112, 112, 112, 0.5);
  padding-left: 1.4rem;
  background-color: transparent;
  color: ${props => props.theme.colors.text};
  font-size: 1.4rem;
  transition: border-color .3s;
  position: relative;
  z-index: 2;
  
  &:focus { outline: none; }
`;

const FormInput = props => {
  const [active, setActive] = useState(false)

  useEffect(() => {
    props.value !== '' && setActive(true)
  }, [props.value])

  return (
      <InputGroup className={active ? 'active' : ''}>
        {props.label && <Label>{props.label}</Label> }
        <Input type={props.type}
               name={props.name}
               placeholder={props.placeholder}
               value={props.value}
               onChange={props.handleChange}
               disabled={props.disabled}
               onFocus={() => setActive(true)}
               onBlur={() => !props.value && setActive(false) && props.success}/>
      </InputGroup>
  );
};
export default FormInput;